import React from 'react'
import RenderTemplateDesign from '../AppComponents/RenderTemplate/RenderTemplateDesign.jsx'

const RenderTemplateForImage = () => {
  return (
    <RenderTemplateDesign/>
  )
}

export default RenderTemplateForImage